(function(root){
 'use strict';
 const data=typeof module!=='undefined'&&module.exports?require('./arya-product-data.js'):root.AryaProductData;
 function normalizeRecord(record){
  const copy=JSON.parse(JSON.stringify(record));
  for(const facts of [copy,...(copy.variants||[]).map(v=>v.overrides||{})])for(const [key,type] of Object.entries(data.types)){
   if(type==='number_decimal'&&facts[key]!==undefined)facts[key]=Number(facts[key]);
   if(type==='list.number_decimal'&&Array.isArray(facts[key]))facts[key]=facts[key].map(Number);
  }
  return copy;
 }
 async function loadCatalogue(endpoint,fetcher,options={}){
  const origin=new URL(endpoint).origin,seen=new Set(),byId=new Map();let next=endpoint;
  while(next){
   const url=new URL(next,endpoint);if(url.origin!==origin)throw Error('Catalogue origin mismatch');
   if(seen.has(url.href))throw Error('Catalogue pagination cycle');if(seen.size>=100)throw Error('Catalogue exceeds supported pagination limit');seen.add(url.href);
   const response=await fetcher(url.href,{cache:'no-store',credentials:'same-origin',headers:{Accept:'text/html'}});
   if(!response.ok)throw Error('Catalogue request failed');
   const page=await response.json();if(page.version!==1||!Array.isArray(page.products))throw Error('Unsupported catalogue response');
   for(const raw of page.products){
    if(raw.schema_version!==1||options.consumer!=='related'&&!(raw.variants||[]).some(v=>{const f={...raw,...v.overrides};return f.facts_status==='verified'&&(f.comparison_ready||f.finder_ready);} ))continue;
    const unsupported=[raw,...(raw.variants||[]).map(v=>v.overrides||{})].some(f=>typeof f.product_family==='string'&&f.product_family.length>0&&!data.enums.product_family.includes(f.product_family));
    if(unsupported){options.onUnsupported?.(String(raw.id));continue;}
    try{const product=data.publicProjection(normalizeRecord(raw),options.consumer||'finder');if(product)byId.set(product.id,product);}catch(error){if(options.consumer==='related'){options.onInvalid?.(String(raw.id));continue;}throw Error('Invalid ready product '+raw.id+': '+error.message);}
   }
   next=page.next?new URL(page.next,url).href:null;
  }
  return [...byId.values()];
 }
 const api={loadCatalogue,normalizeRecord};if(typeof module!=='undefined'&&module.exports)module.exports=api;else root.AryaCatalogue=api;
})(typeof window!=='undefined'?window:globalThis);

